import { lazy, Suspense } from "react";
import { RouteObject } from "../../helpers/tixxt-router";
import Loading from "../shared/Loading";

const NewQuestionnairePage = lazy(() => import("./NewQuestionnairePage"));
const EditQuestionnairePage = lazy(() => import("./EditQuestionnairePage"));
const QuestionnairePage = lazy(() => import("./QuestionnairePage"));
const QuestionnaireResultsPage = lazy(
  () => import("./QuestionnaireResultsPage"),
);

// Questionnaires (tixxt/core#548), created on their own page and posted like an appointment
const questionnairesRoutes: RouteObject[] = [
  {
    path: "/questionnaires/new",
    element: (
      <Suspense fallback={<Loading />}>
        <NewQuestionnairePage />
      </Suspense>
    ),
  },
  {
    path: "/questionnaires/:questionnaireId",
    element: (
      <Suspense fallback={<Loading />}>
        <QuestionnairePage />
      </Suspense>
    ),
  },
  {
    path: "/questionnaires/:questionnaireId/edit",
    element: (
      <Suspense fallback={<Loading />}>
        <EditQuestionnairePage />
      </Suspense>
    ),
  },
  {
    path: "/questionnaires/:questionnaireId/results",
    element: (
      <Suspense fallback={<Loading />}>
        <QuestionnaireResultsPage />
      </Suspense>
    ),
  },
];

export default questionnairesRoutes;
